import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ConnectFormDirective } from './connect-form/connect-form.directive'
import { PatchFormGroupValuesDirective } from './patch-form-group-values/patch-form-group-values.directive'
import { S3FileDirective } from './s3-file/s3-file.directive'
import { CheckboxValueDirective } from './checkbox-value/checkbox-value.directive'
import { NumbersOnlyDirective } from './numbers-only/numbers-only.directive'
import { InfiniteScrollTriggerDirective } from './infinite-scroll-trigger/infinite-scroll-trigger.directive'
import { TrackByPropertyDirective } from './track-by-property/track-by-property.directive'
import { MatStepperScrollToTopDirective } from './mat-stepper-scroll-to-top/mat-stepper-scroll-to-top.directive'
import { FocusInputDirective } from './focus-input/focus-input.directive'
import { GbRouteNewTabDirective } from './gb-route-new-tab/gb-route-new-tab.directive'

@NgModule({
  imports: [CommonModule],
  declarations: [
    ConnectFormDirective,
    PatchFormGroupValuesDirective,
    S3FileDirective,
    CheckboxValueDirective,
    NumbersOnlyDirective,
    InfiniteScrollTriggerDirective,
    TrackByPropertyDirective,
    MatStepperScrollToTopDirective,
    FocusInputDirective,
    GbRouteNewTabDirective,
  ],
  exports: [
    ConnectFormDirective,
    PatchFormGroupValuesDirective,
    S3FileDirective,
    CheckboxValueDirective,
    NumbersOnlyDirective,
    InfiniteScrollTriggerDirective,
    TrackByPropertyDirective,
    MatStepperScrollToTopDirective,
    FocusInputDirective,
    GbRouteNewTabDirective,
  ],
})
export class SharedUtilsDirectivesModule {}
